export default __webpack_public_path__ + "static/media/OCRAStd.a92debed.otf";